/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

export enum AuthSessionVariable {
  FIDP = 'fidp',
  RETURN_TO_URL = 'returnToUrl',
  ORG_UUID = 'orgUuid',
  INIT_URL = 'initUrl',
  REGION = 'region',
  CLOUD_TYPE = 'cloudType',
}

export function getSessionItem(key: AuthSessionVariable) {
  return window.sessionStorage.getItem(key);
}

export function setSessionItem(key: AuthSessionVariable, value: string) {
  window.sessionStorage.setItem(key, value);
}

export function removeAllAuthSessionItems() {
  const sessionVariables = Object.values(AuthSessionVariable);
  sessionVariables.forEach((sessionVariable) => {
    window.sessionStorage.removeItem(sessionVariable);
  });
}

export type SignInConfig = {
  fidp: string;
  username?: string;
};
